export const PRODUCT_TYPES = {
    PHARMACY: "pharmacy",
    FOOD: "food",
    VACCINES: "vaccines",
    SERVICES: "services",
    VETCHECK: "vetcheck",
    WELLNESS: "wellness",
};